import { createI18n } from 'vue-i18n'
import enGB from '@/locales/en-GB.json'
import deDE from '@/locales/de-DE.json'
import deAT from '@/locales/de-AT-common.json'
import deATFormal from '@/locales/de-AT-formal.json'
import deATInformal from '@/locales/de-AT-informal.json'
const i18n = createI18n({
  legacy: false,
  locale: 'de-DE',
  fallbackLocale: {
    'de-AT': ['de-DE']
  },
  messages: {
    // @ts-ignore
    'en-GB': enGB,
    'de-DE': deDE,
    'de-AT': deAT,
    'de-AT-informal': deATInformal,
    'de-AT-formal': deATFormal
  }
})

export default i18n
